<template>
  <div id="ActivityList">
    <div class="ActivityList-header">
      <van-icon name="arrow-left" class="arrow-left" />
      <span class="ActivityList-header-title">活动列表</span>
    </div>
    <div class="ActivityList-height"></div>
    <div class="line-grad-bgColor"></div>
    <div class="ActivityList-order" v-for="(item, index) in list" :key="index">
      <div class="ActivityList-order-top">
        <span class="ActivityList-order-left">
          <img
            class="ActivityList-order-left-img"
            src="@/assets/localLife/美团优选@3x.png"
            alt=""
          />
          <span> 肯德基 </span>
        </span>
        <span class="ActivityList-order-right"> 至2021-06-09 10:00结束 </span>
      </div>
      <div class="ActivityList-order-bottom">
        <img
          class="ActivityList-order-bottom-img"
          src="@/assets/cms/notice.png"
          alt=""
        />
        <span class="ActivityList-order-bottom-text">
          活动名称奥德赛撒大大的爱仕达as大神撒大神大奥德赛as撒大…
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [{}, {}, {}, {}, {}, {}, {}],
    };
  },
  created() {},
  methods: {},
  beforeCreate() {
    this.$nextTick(() => {
      document.body.setAttribute("style", "background:#F5F6F7");
    });
  },
  //实例销毁之前钩子--移除body 标签的属性style
  beforeDestroy() {
    document.body.removeAttribute("style");
  },
};
</script>
<style lang="less" scoped>
#ActivityList {
  .ActivityList-header {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 4rem;
    line-height: 4rem;
    background: #ff8700;
    color: #fff;
    z-index: 20;
    .arrow-left {
      color: #fff;
      margin-left: 0.8rem;
      line-height: 4rem;
    }
    .ActivityList-header-title {
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #fff;
    }
  }
  .ActivityList-height {
    height: 4rem;
  }
  .line-grad-bgColor {
    position: fixed;
    width: 100%;
    height: 6rem;
    top: 3.9rem;
    background: linear-gradient(180deg, #ff8700 10%, #f5f6f7 100%);
    z-index: 1;
  }
  .ActivityList-order {
    position: relative;
    width: 94%;
    margin: 0px 3%;
    min-height: 8rem;
    background: #fff;
    border-radius: 0.3rem;
    z-index: 15;
    margin-bottom: 0.8rem;
    .ActivityList-order-top {
      padding-top: 0.8rem;
      .ActivityList-order-left {
        margin-left: 0.8rem;
        color: #333333;
        font-size: 0.95rem;
        font-weight: bold;
        .ActivityList-order-left-img {
          width: 1.5rem;
          vertical-align: middle;
        }
      }
      .ActivityList-order-right {
        float: right;
        margin-right: 0.8rem;
        color: #999999;
        font-size: 0.8rem;
      }
    }
    .ActivityList-order-bottom {
      color: #333333;
      padding: 0.7rem 0rem;
      .ActivityList-order-bottom-img {
        width: 5rem;
        height: 5rem;
        margin-left: 0.7rem;
        border-radius: 0.3rem;
        vertical-align: top;
      }
      .ActivityList-order-bottom-text {
        display: inline-block;
        max-width: 70%;
        margin-left: 0.5rem;
        line-height: 1.2rem;
        font-size: 0.95rem;
        font-weight: bold;
      }
    }
  }
}
</style>